<template>
  <v-dialog v-model="dialog" width="650" persistent>
    <v-card>
      <v-card-title class="redColor">
        <span class="headline text-white">{{ $t("parts.table.actions") }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container fluid>
            <v-row dense>
              <!-- ALERT -->
              <v-col cols="12">
                <v-alert
                  :model-value="alert.value"
                  type="warning"
                  variant="outlined"
                >
                  <v-row align="center" justify="center">
                    <v-col cols="12" sm="6">
                      {{ alert.message }}
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-row>
                        <v-btn
                          variant="outlined"
                          small
                          color="success"
                          @click="
                            confirm = true;
                            alert.value = false;
                          "
                        >
                          {{ $t("parts.inventory.actions.alert.yes") }}
                        </v-btn>
                        <v-btn
                          variant="outlined"
                          small
                          color="error"
                          @click="
                            confirm = false;
                            alert.value = false;
                          "
                        >
                          {{ $t("parts.inventory.actions.alert.no") }}
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-alert>
              </v-col>
              <!-- SWITCH -->
              <v-col cols="12">
                <v-row>
                  <v-col cols="6" sm="3">
                    <v-switch
                      v-model="switchS"
                      :disabled="
                        $store.getters.role === 'User' ||
                        $store.getters.role === 'EbayOperator'
                      "
                      :label="$t('parts.inventory.actions.sell')"
                      color="green"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <!-- CLIENT AUTOCOMPLETE -->
              <v-col
                v-if="
                  switchS &&
                  $store.getters.role !== 'User' &&
                  $store.getters.role !== 'EbayOperator'
                "
                cols="12"
              >
                <v-row>
                  <v-col cols="12" xs="6" sm="8" md="8">
                    <v-autocomplete
                      v-model="client"
                      :items="clients"
                      :label="$t('parts.inventory.actions.select_client')"
                      :rules="rules.requiredSelect"
                      color="red-darken-1"
                      :item-title="() => ''"
                      item-value="_id"
                      prepend-icon="mdi-account"
                      return-object
                    >
                      <template #selection="{ item }">
                        <span>
                          {{ item.raw.name }} {{ item.raw.surname }}
                        </span>
                      </template>
                      <template #item="{ props, item }">
                        <v-list-item v-bind="props">
                          <v-list-item-title>
                            {{ item.raw.name }} {{ item.raw.surname }}
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col xs="6" sm="4" md="4">
                    <v-btn color="success" class="mt-3 px-2" @click="addClient">
                      {{ $t("parts.inventory.actions.add_client") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <!-- NOTES -->
              <v-col
                v-if="
                  switchS &&
                  $store.getters.role !== 'User' &&
                  $store.getters.role !== 'EbayOperator'
                "
                cols="12"
              >
                <v-textarea
                  v-model="notes"
                  variant="outlined"
                  label="Notes"
                  color="red-darken-2"
                />
              </v-col>
              <!-- TOTAL PRICE / CASH / DIFFERENCE -->
              <v-col
                v-if="
                  switchS &&
                  $store.getters.role !== 'User' &&
                  $store.getters.role !== 'EbayOperator'
                "
                cols="12"
              >
                <v-row>
                  <!-- TOTAL PRICE -->
                  <v-col cols="4">
                    <v-text-field
                      v-model="part.price"
                      :label="$t('parts.inventory.actions.total_price')"
                      color="red-darken-1"
                      type="number"
                      min="0"
                      step="0.01"
                      @input="validateNumber('price')"
                    />
                  </v-col>
                  <!-- CHANGE / DIFFERENCE -->
                  <v-col cols="4">
                    <v-text-field
                      v-if="cash - part.price > 0"
                      v-model="difference"
                      :label="$t('parts.inventory.actions.change')"
                      color="red-darken-1"
                      disabled
                    />
                    <v-text-field
                      v-else
                      v-model="difference"
                      :label="$t('parts.inventory.actions.difference')"
                      color="red-darken-1"
                      disabled
                    />
                  </v-col>
                  <!-- CASH -->
                  <v-col cols="4">
                    <v-text-field
                      v-model="cash"
                      :label="$t('parts.inventory.actions.cash')"
                      color="red-darken-1"
                      type="number"
                      min="0"
                      step="0.01"
                      :max="part.price"
                      @input="validateNumber('cash')"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("parts.inventory.actions.cancel") }}
        </v-btn>
        <v-btn
          v-if="switchS"
          :disabled="
            !valid ||
            (client &&
              typeof client === 'object' &&
              Object.keys(client).length < 1)
          "
          :loading="loading"
          color="green"
          variant="outlined"
          @click="sell"
        >
          {{ $t("parts.inventory.actions.sell") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import getRequest from "../../api/getRequest";
import putRequest from "../../api/putRequest";

export default {
  data: () => ({
    dialog: false,
    valid: false,
    loading: false,
    switchS: true,
    alert: {
      value: false,
      message: "",
    },
    confirm: false,
    part: {},
    sale: {
      part: {},
      client: {},
    },
    client: {},
    clients: [],
    cash: 0,
    notes: "",
    rules: {
      requiredLetters: [
        (v) => !!v || "Please fill this field",
        (v) => /[A-Za-z]/.test(v) || "Only letters are allowed",
      ],
      requiredNumbers: [
        (v) => !!v || "Please fill this field",
        (v) => /[0-9]/.test(v) || "Only numbers are allowed",
      ],
      requiredSelect: [(v) => (v && !!v.name) || "Item is required"],
    },
  }),
  computed: {
    difference() {
      if (this.cash - this.part.price >= 0) {
        const difference = (this.cash - this.part.price).toString();
        const trimedNumber = difference.substring(0, 6);
        return trimedNumber;
      }
      const difference = (this.part.price - this.cash).toString();
      const trimedNumber = difference.substring(0, 6);
      return trimedNumber;
    },
  },
  watch: {
    switchS(value) {
      if (value) {
        this.alert.value = false;
        this.alert.message = "";
      }
    },
    client(value) {
      if (value && typeof value === "object" && Object.keys(value).length < 1) {
        this.sale.client_id = value._id;
        this.sale.client.name = value.name;
        this.sale.client.surname = value.surname;
        this.sale.client.email = value.email;
        this.sale.client.phone = value.phone;
      }
    },
  },
  methods: {
    open(part) {
      this.getClients();
      this.part = part;
      this.cash = part.price;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.part = {};
      this.sale = {
        part: {},
        client: {},
      };
      this.confirm = false;
      this.alert.value = false;
      this.alert.message = "";
      this.cash = 0;
      this.notes = "";
      this.client = {};
      this.clients = [];
      this.switchS = true;
      this.$emit("close");
    },
    sell() {
      this.loading = true;
      putRequest("/temporary-part/insert/sell", "", {
        user_id: this.$store.getters.userId,
        institution_id: this.$store.getters.institutionId,
        part_id: this.part._id,
        client_id: this.client._id,
        price: this.part.price,
        currency: "EUR",
        cash: this.cash,
        notes: this.notes,
      })
        .then((response) => {
          if (response) {
            this.loading = false;
            this.close();
          }
        })
        .catch((error) => {
          if (error) {
            this.loading = false;
            this.close();
          }
        });
    },
    searchClient(search) {
      getRequest(
        "/client/search",
        `search=${search}&role=${
          this.$store.getters.role
        }&institution_id=${this.$store.getters.institutionId}`,
      )
        .then(() => {})
        .catch(() => {});
    },
    getClients() {
      getRequest(
        "/client/",
        `role=${this.$store.getters.role}&institution_id=${
          this.$store.getters.institutionId
        }`,
      )
        .then((response) => {
          this.clients = response.clients;
        })
        .catch(() => {});
    },
    addClient() {
      this.$emit("add-client");
    },
    hide() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
    },
    validateNumber(field) {
      if (this[field] < 0 || isNaN(this[field])) {
        this[field] = "";
      }
    },
  },
};
</script>
